export default __webpack_public_path__ + "static/media/logo-on-white.3dd74194.png";